'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.0002 3.33335C20.3633 3.1518 20.7318 3.56925 20.5066 3.90703L20.0674 4.56582C20.023 4.63241 19.9659 4.68954 19.8993 4.73393L18.0551 5.9634C18.0186 5.98775 17.9845 6.01566 17.9535 6.0467L17.8049 6.19528C17.5446 6.45563 17.5446 6.87774 17.8049 7.13809L18.1954 7.52861C18.4558 7.78896 18.4558 8.21107 18.1954 8.47143L17.6733 8.99358C17.4704 9.19649 17.1604 9.24679 16.9037 9.11846L16.5964 8.96483C16.2671 8.80017 15.8667 8.93365 15.702 9.26297L15.457 9.75303C15.3779 9.91117 15.2393 10.0314 15.0715 10.0873L13.4361 10.6325C13.3682 10.6551 13.297 10.6667 13.2253 10.6667H12.4122C12.1597 10.6667 11.9288 10.8094 11.8159 11.0352L11.6316 11.4037C11.467 11.7331 11.0665 11.8665 10.7372 11.7019L8.76359 10.7151C8.6995 10.683 8.641 10.6409 8.59033 10.5902L7.52876 9.52861C7.40373 9.40359 7.3335 9.23402 7.3335 9.05721V8.47143C7.3335 8.21108 7.54455 8.00002 7.8049 8.00002C7.92992 8.00002 8.04983 7.95035 8.13823 7.86195L9.13823 6.86195C9.26326 6.73693 9.43283 6.66669 9.60964 6.66669H10.1863C10.4733 6.66669 10.728 6.48307 10.8188 6.21084L11.1474 5.22501C11.2537 4.90605 11.5809 4.71617 11.9106 4.78211L14.5198 5.30395C14.6166 5.32331 14.7165 5.32094 14.8123 5.297L17.2625 4.68444C17.3097 4.67264 17.3554 4.65571 17.399 4.63396L20.0002 3.33335Z",
          fill: "#E7832C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0002 16C14.3684 16 14.6668 15.7015 14.6668 15.3334C14.6668 14.9652 14.3684 14.6667 14.0002 14.6667C13.632 14.6667 13.3335 14.9652 13.3335 15.3334C13.3335 15.7015 13.632 16 14.0002 16Z",
          fill: "#445128"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.9648 12.0704C19.2941 12.235 19.4276 12.6355 19.263 12.9648C18.84 13.8107 18.0321 14.3924 17.4141 14.7455C17.0938 14.9285 16.7978 15.0651 16.5816 15.1561C16.4731 15.2018 16.3836 15.2365 16.3197 15.2602C16.2878 15.2721 16.2622 15.2813 16.2438 15.2878L16.2216 15.2955L16.2148 15.2978L16.2124 15.2986L16.2112 15.299C16.2112 15.299 16.2108 15.2991 16 14.6667",
          fill: "#445128"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.03519 12.0704C8.70587 12.235 8.57239 12.6355 8.73705 12.9648C9.16 13.8107 9.96793 14.3924 10.5859 14.7455C10.9062 14.9285 11.2022 15.0651 11.4184 15.1561C11.5269 15.2018 11.6164 15.2365 11.6803 15.2602C11.7122 15.2721 11.7378 15.2813 11.7562 15.2878L11.7784 15.2955L11.7852 15.2978L11.7876 15.2986L11.7888 15.299C11.7888 15.299 11.7892 15.2991 12 14.6667",
          fill: "#445128"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0V20H28V0H0ZM27.5 0.5H0.5L0.5 19.5H27.5V0.5Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagCyAsset = forwardRef(FlagCyAsset);

export { VpFlagCyAsset as default };
